import React from "react";
import Skeleton from "react-loading-skeleton";
const SkeletonPMCLinkedRegForm = () => {
  return (
    <React.Fragment>
      <br/>
       <Skeleton width={252} height={24}/>
       <br/>
       <Skeleton width={512} height={24}/>
       <br/>
       <Skeleton width={512} height={18}/>
       <br/>
       <br/>
       <Skeleton width={252} height={24}/>
       <br/>
       <Skeleton width={512} height={24}/>
       <br/>
       <Skeleton width={512} height={18}/>       
    </React.Fragment>
  );
};
export default SkeletonPMCLinkedRegForm;
